import React, { createContext, useContext, useRef, useState, useCallback } from "react";

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
  const [allReady, setAllReady] = useState(false);
  const [preloaderDone, setPreloaderDone] = useState(false);
  const pending = useRef(0);
  const total = useRef(0);

  const register = useCallback(() => {
    pending.current += 1;
    total.current += 1;
  }, []);

  const done = useCallback(() => {
    pending.current -= 1;
    if (pending.current <= 0) {
      setAllReady(true);
    }
  }, []);

  return (
    <LoadingContext.Provider value={{ register, done, allReady, preloaderDone, setPreloaderDone }}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoadingContext() {
  return useContext(LoadingContext);
}
